import type { Report } from '@/types/Models/Report'
import type { ReportStoreState } from '@/types/Store'
import { defineStore } from 'pinia'
import ReportsProxy from '@/proxies/ReportsProxy'

export const useReportStore = defineStore('report', {
  state: (): ReportStoreState => ({ reports: [], loading: false }),
  getters: {
    list: (state: ReportStoreState) => state.reports,
    isLoading: (state: ReportStoreState) => state.loading,
  },
  actions: {
    fetchAll() {
      this.loading = true
      return new ReportsProxy()
        .all()
        .then((response) => {
          this.reports = response.data as Report[]
          return response
        })
        .finally(() => {
          this.loading = false
        })
    },
    update(id: number, payload: Partial<Report>) {
      return new ReportsProxy().update(id, payload)
    },
  },
})

export type ReportStore = ReturnType<typeof useReportStore>
